var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _path3, _rect7, _rect8, _rect9, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepSanctionsCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 58,
    viewBox: "0 0 69 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 60,
    height: 24,
    rx: 5.308,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 8.70703,
    width: 8.49779,
    height: 7.08149,
    rx: 2.8326,
    fill: "#C3F3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.862 11.8633L58.0938 12.6315L57.6328 12.1705",
    stroke: "#40DA9E",
    strokeWidth: 0.67747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2492 15.4302V15.4302C56.4891 15.4302 55.0625 14.0037 55.0625 12.2436V12.2436C55.0625 10.4835 56.4891 9.05688 58.2492 9.05688V9.05688C60.0093 9.05688 61.4358 10.4835 61.4358 12.2436V12.2436C61.4358 14.0037 60.0093 15.4302 58.2492 15.4302Z",
    stroke: "#C3F3E1",
    strokeWidth: 0.531112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6.5625,
    width: 11.5493,
    height: 3.0769,
    rx: 1.53845,
    fill: "#E3E7EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12.9141,
    width: 22.1184,
    height: 3.0769,
    rx: 1.53845,
    fill: "#E3E7EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 60,
    height: 24,
    rx: 5.308,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 34,
    width: 8.4928,
    height: 7.07733,
    rx: 2.83093,
    fill: "#F48D53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6007 36.1233L57.5391 37.1849L58.9545 37.8926L57.8929 38.9542",
    stroke: "white",
    strokeWidth: 0.707733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "#E3E7EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9922,
    y: 37.3457,
    width: 28.2176,
    height: 3.1848,
    rx: 1.5924,
    transform: "rotate(-0.393915 19.9922 37.3457)",
    fill: "#E3E7EE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 42.2978,
    height: 42.2978,
    rx: 21.1489,
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1118 45.2622H14.2761C13.6883 45.2611 13.212 44.7849 13.2109 44.197V43.333C13.2183 40.8743 15.2102 38.8833 17.6689 38.877H24.7189C27.1776 38.8833 29.1696 40.8743 29.1769 43.333V44.197C29.1759 44.7849 28.6996 45.2611 28.1118 45.2622Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.68277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1972 34.7206C18.8188 34.7206 16.8899 32.7942 16.8867 30.4158C16.8836 28.0375 18.8074 26.106 21.1857 26.0996C23.5641 26.0933 25.4981 28.0145 25.5077 30.3929C25.5112 31.5387 25.0588 32.639 24.2501 33.4508C23.4415 34.2627 22.343 34.7196 21.1972 34.7206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepSanctionsCheckLarge);
export default __webpack_public_path__ + "static/media/pep_sanctions_check_large.e51ab4147db1beae3cba74bb4a838301.svg";
export { ForwardRef as ReactComponent };